<p class="header-font">
  <ng-content></ng-content>
</p>
